import { View } from 'react-native';

import { Text, YStack, createMqStyles, tokens } from '@fhs/ui';

import { productSummaryRegionWebProps } from './product-name-and-image/product-summary-web-a11y-props';

const LEGAL_COPY_LINES = [
  'Calories will vary based on modifications made to an item. Product availability, prices, offers and discounts may vary from in-restaurant.',
  '2,000 calories a day is used for general nutrition advice, but calorie needs vary.',
] as const;

export const MenuListLegalText = () => {
  const mqStyles = useMqStyles();
  const legalCopyAccessibilityLabel = LEGAL_COPY_LINES.join(' ');
  return (
    <YStack style={mqStyles.footer}>
      <View style={mqStyles.divider} accessible={false} importantForAccessibility="no" />
      <YStack
        accessible={true}
        accessibilityLabel={legalCopyAccessibilityLabel}
        {...(productSummaryRegionWebProps(legalCopyAccessibilityLabel) ?? {})}
        style={mqStyles.legalTextArea}
      >
        <View accessibilityElementsHidden importantForAccessibility="no-hide-descendants">
          <Text.Paragraph accessible={false} importantForAccessibility="no" size="sm" style={mqStyles.legalText}>
            {LEGAL_COPY_LINES[0]}
          </Text.Paragraph>
          <Text.Paragraph accessible={false} importantForAccessibility="no" size="sm" style={mqStyles.legalText}>
            {LEGAL_COPY_LINES[1]}
          </Text.Paragraph>
        </View>
      </YStack>
    </YStack>
  );
};

const useMqStyles = createMqStyles({
  footer: {
    $base: {
      marginTop: 18,
      marginBottom: 8,
    },
  },
  legalTextArea: {
    $base: {
      paddingHorizontal: 16,
      paddingTop: 24,
      gap: 8,
      // Make space for the scroll to top button
      // so it doesn't cover legal text
      marginRight: 48,
    },
    $gteDesktop: {
      paddingTop: 44,
      paddingBottom: 16,
      paddingHorizontal: 32,
      marginRight: 0,
    },
  },
  divider: {
    $base: {
      height: 1,
      backgroundColor: tokens.colors.$blackOpacity10,
    },
  },
  legalText: {
    $base: {
      color: tokens.colors.$disabledText,
    },
    $gteDesktop: {
      textAlign: 'center',
    },
  },
});
